import * as React from 'react'
import cx from 'classnames'
import TwitterSliderCustom from 'components/TwitterSliderCustom'
import { Heading } from 'components/basic/Heading'
import styles from './TwitterSlider.module.scss'
import { LinkWithArrow } from 'components/basic/LinkWithArrow/LinkWithArrow'

/**
 * @deprecated Remove ASAP, Dependent only on <PodTechCover/>
 */
const TwitterSlider = (props) => {
	return (
		<div className={cx(styles.outer_container, 'inner-paddings-y')}>
			<div className="max-1440 inner-paddings-x">
				<Heading
					title={props.title || 'Over 80,000 people love the Pod'}
					type="h3"
					titleClass={cx('h3')}
				/>
			</div>
			<TwitterSliderCustom isCoverOnly={false} />
			<div className="tac">
				<LinkWithArrow
					href="/wall-of-love"
					id="cover-lp-twitter-more-reviews"
					className={styles.white_link}
				>
					Read more reviews
				</LinkWithArrow>
			</div>
		</div>
	)
}

export default TwitterSlider
